export * from './baCard.component';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/components/baCard/index.ts